import { jsx as _jsx } from "react/jsx-runtime";
import { IntlProvider } from 'react-intl';
import { useGetTranslationsQuery, } from '../graphql/__generated__/graphql.autogenerated';
import useWidgetContext from '../hooks/useWidgetContext';
export const TranslationsProvider = {
    hooks: () => {
        const { data } = useGetTranslationsQuery();
        return { data };
    },
    initialize: args => {
        const { data } = args;
        const messages = data?.translations.reduce((acc, curr) => {
            if (curr?.code) {
                return { ...acc, [curr.code]: curr.value };
            }
            return acc;
        }, {});
        return Promise.resolve({ messages });
    },
    component: ({ messages, children }) => {
        const { configuration } = useWidgetContext();
        const intlCustomErrorHandler = () => {
            const mode = String(process.env.NODE_ENV);
            if (mode === 'production' || mode === 'coverage') {
                return;
            }
            return console.error;
        };
        return (_jsx(IntlProvider, { onError: intlCustomErrorHandler(), locale: configuration.dimensions.language, messages: messages, children: children }, void 0));
    },
};
//# sourceMappingURL=Translations.provider.js.map